import { Suspense, lazy, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import Home from './pages/Home/Home';
import { getUserInfoByToken } from './store/authSlice';
import checkLogined from './utils/loader/checkLogined';
import changeBankInfoLoader from './utils/loader/changeBankInfoLoader';
import withdrawLoader from './utils/loader/withdrawLoader';
import withdrawHistoryLoader from './utils/loader/withdrawHistoryLoader';
import protectUser from './utils/loader/protectUser';
import FIndTikTokOrder from './pages/Merchant/TikTok/FIndTikTokOrder';
import ErrorDefault from './pages/Error/Error';
import Notification from './pages/Notification';
import FindShopeeOrder from './pages/Merchant/ShopeeLive/FindShopeeOrder';
import checkLiveUsers from './utils/loader/checkLiveUsers';
import ShopeeLiveV2 from './pages/Merchant/ShopeeLive/ShopeeLiveV2';
import ShopeeXu from './pages/Merchant/ShopeeXu/ShopeeXu';

// import ShopeeVideo from './pages/Merchant/ShopeeVideo/ShopeeVideo';
import ShopeeVideoMultiLinkNoLogin from './pages/Merchant/ShopeeVideo/MultipleLink/MultipleLinkNoLogin';
import Game from './pages/Game/Game';
import GameCungDau from './pages/Game/GameCungDau';
import ShopeeXuV2 from './pages/Merchant/ShopeeXu/ShopeeXuV2';
import ConvertLink from './pages/Tools/ConvertLink';
import Shopee from './pages/Merchant/Shopee/Shopee';

const Category = lazy(() => import('./pages/Merchant/Shopee/Category'));
const Signup = lazy(() => import('./pages/Auth/Signup/Signup'));
const Login = lazy(() => import('./pages/Auth/Login/Login'));
const ForgotPW = lazy(() => import('./pages/Auth/ForgotPW/ForgotPW'));
const About = lazy(() => import('./pages/About'));

const User = lazy(() => import('./pages/User'));
const UserInfo = lazy(() => import('./pages/User/UserInfo/UserInfo'));
const ChangeEmail = lazy(() => import('./pages/User/UserInfo/ChangeEmail'));
const ChangePassword = lazy(() =>
    import('./pages/User/UserInfo/ChangePassword')
);
const ChangeUserName = lazy(() =>
    import('./pages/User/UserInfo/ChangeName/ChangeUserName')
);
const ChangeBankInfo = lazy(() =>
    import('./pages/User/UserInfo/ChangeBankInfo')
);
const Order = lazy(() => import('./pages/User/Order'));
const Withdraw = lazy(() => import('./pages/User/Withdraw'));
const WithdrawHistory = lazy(() => import('./pages/User/WithdrawHistory'));
const Redirect = lazy(() => import('./pages/Redirect/Redirect'));
const Lazada = lazy(() => import('./pages/Merchant/Lazada/Lazada'));
const TikTok = lazy(() => import('./pages/Merchant/TikTok'));
const Help = lazy(() => import('./pages/Help/index'));
const HelpCenter = lazy(() => import('./pages/Help/HelpCenter'));
const OrderHelperMain = lazy(() =>
    import('./pages/Help/OrderHelper/OrderHelperMain')
);
const OrderHelper = lazy(() => import('./pages/Help/OrderHelper/OrderHelper'));
const LostOrder = lazy(() => import('./pages/Help/OrderHelper/LostOrder'));
const CommissionIncorrect = lazy(() =>
    import('./pages/Help/OrderHelper/CommissionIncorrect')
);
const Guide = lazy(() => import('./pages/Help/Guide'));
const GuideMain = lazy(() => import('./pages/Help/Guide/GuideMain'));
const GetDisCount = lazy(() => import('./pages/Help/Guide/GetDiscount'));
const HowToChietKhauProWork = lazy(() =>
    import('./pages/Help/Guide/HowToWork')
);
const HowToWithdraw = lazy(() => import('./pages/Help/Guide/HowToWithDraw'));
const GhostOrder = lazy(() => import('./pages/GhostOrder'));

function App() {
    const dispatch = useDispatch();

    useEffect(() => {
        if (localStorage.getItem('access_token')) {
            dispatch(getUserInfoByToken());
        }
    }, [dispatch]);
    const router = createBrowserRouter([
        {
            path: '/',
            element: <Home />,
            errorElement: <ErrorDefault />,
        },
        {
            path: '/error',
            element: <ErrorDefault />,
        },
        {
            path: '/signup',
            element: (
                <Suspense>
                    <Signup />
                </Suspense>
            ),
            loader: checkLogined,
            errorElement: <ErrorDefault />,
        },
        {
            path: '/login',
            element: (
                <Suspense>
                    <Login />
                </Suspense>
            ),
            loader: checkLogined,
            errorElement: <ErrorDefault />,
        },
        {
            path: '/forgot-password',
            element: (
                <Suspense>
                    <ForgotPW />
                </Suspense>
            ),
            errorElement: <ErrorDefault />,
        },
        {
            path: '/user-info',
            loader: protectUser,
            element: (
                <Suspense>
                    <User />
                </Suspense>
            ),
            errorElement: <ErrorDefault />,
            children: [
                {
                    index: true,
                    element: <UserInfo />,
                },
                {
                    path: 'change-user-name',
                    element: <ChangeUserName />,
                },
                {
                    path: 'change-email',
                    element: <ChangeEmail />,
                },
                {
                    path: 'change-password',
                    element: <ChangePassword />,
                },
                // {
                //     path: 'ref',
                //     element: <Ref />,
                // },
                {
                    path: 'change-bank-info',
                    element: <ChangeBankInfo />,
                    loader: changeBankInfoLoader,
                },
                {
                    path: 'withdraw',
                    children: [
                        {
                            index: true,
                            element: (
                                <Suspense>
                                    <Withdraw />
                                </Suspense>
                            ),
                            loader: withdrawLoader,
                        },
                        {
                            path: 'history',
                            element: (
                                <Suspense>
                                    <WithdrawHistory />
                                </Suspense>
                            ),
                            loader: withdrawHistoryLoader,
                        },
                    ],
                },
                {
                    path: 'order',
                    element: <Order />,
                    errorElement: <ErrorDefault />,
                },
            ],
        },

        {
            path: '/shopee',
            children: [
                {
                    index: true,
                    element: <Shopee />,
                    errorElement: <ErrorDefault />,
                },
                {
                    path: ':category',
                    element: (
                        <Suspense>
                            <Category />
                        </Suspense>
                    ),
                    errorElement: <ErrorDefault />,
                },
            ],
        },
        {
            path: 'vongquayshopee',
            element: <ShopeeXu />,
        },
        {
            path: 'vongquayshopeeV2',
            element: <ShopeeXuV2 />,
        },
        {
            path: 'minigame',
            element: <Game />,
        },
        {
            path: 'minigame/game_cung_dau',
            element: <GameCungDau />,
        },
        {
            path: '/lazada',
            element: (
                <Suspense>
                    <Lazada />
                </Suspense>
            ),
        },
        {
            path: '/tiktok',

            children: [
                {
                    index: true,
                    element: (
                        <Suspense>
                            <TikTok />
                        </Suspense>
                    ),
                    errorElement: <ErrorDefault />,
                },
                {
                    path: 'find',
                    element: <FIndTikTokOrder />,
                    errorElement: <ErrorDefault />,
                },
            ],
        },
        {
            path: 'shopeelive',
            children: [
                {
                    index: true,
                    element: <ShopeeLiveV2 />,
                },
                {
                    path: 'find',
                    element: <FindShopeeOrder />,
                    loader: checkLiveUsers,
                },
                {
                    path: 'v2',
                    element: <ShopeeLiveV2 />,
                },
            ],
        },
        {
            path: 'shopeevideo',
            element: <ShopeeVideoMultiLinkNoLogin />,
            errorElement: <ErrorDefault />,
        },
        {
            path: '/redirect',
            element: (
                <Suspense>
                    <Redirect />
                </Suspense>
            ),
        },
        {
            path: '/help',
            element: (
                <Suspense>
                    <Help />
                </Suspense>
            ),
            errorElement: <ErrorDefault />,
            children: [
                {
                    index: true,
                    element: <HelpCenter />,
                },
                {
                    path: 'order-helper',
                    element: (
                        <Suspense>
                            <OrderHelperMain />
                        </Suspense>
                    ),
                    children: [
                        {
                            element: <OrderHelper />,
                            index: true,
                        },
                        {
                            path: 'lost',
                            element: <LostOrder />,
                        },
                        {
                            path: 'incorrect-commission',
                            element: <CommissionIncorrect />,
                        },
                    ],
                },
                {
                    path: 'guide',
                    element: (
                        <Suspense>
                            <GuideMain />
                        </Suspense>
                    ),
                    children: [
                        {
                            index: true,
                            element: <Guide />,
                        },
                        {
                            element: <GetDisCount />,
                            path: 'how-to-get-discount',
                        },
                        {
                            element: <HowToChietKhauProWork />,
                            path: 'how-to-work',
                        },
                        {
                            element: <HowToWithdraw />,
                            path: 'how-to-withdraw',
                        },
                    ],
                },
            ],
        },
        {
            path: 'about',
            element: (
                <Suspense>
                    <About />
                </Suspense>
            ),
            errorElement: <ErrorDefault />,
        },
        {
            path: 'notification',
            element: <Notification />,
            errorElement: <ErrorDefault />,
        },
        {
            path: 'un-shopee',
            element: (
                <Suspense>
                    <GhostOrder />
                </Suspense>
            ),
            loader: protectUser,
            errorElement: <ErrorDefault />,
        },
        {
            path: 'convertlink',
            element: <ConvertLink />,
        },
    ]);
    return <RouterProvider router={router} />;
}

export default App;
